import { FocusKeyManager } from '@angular/cdk/a11y';
import { AfterViewInit, Component, HostListener, QueryList, ViewChildren } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Logout, SwitchProfile } from '../../state/app.actions';
import { AppState } from '../../state/app.state';
import { ListItemComponent } from '../list-item/list-item.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit {
  @ViewChildren(ListItemComponent) items: QueryList<ListItemComponent>;

  protected _isSwitchProfileModalOpen: boolean = false;
  private keyManager: FocusKeyManager<ListItemComponent>;

  institutionName$ = this.store.select(AppState.institutionName);

  menuOpen = false;
  public canSwitchProfile$: Observable<boolean> = this.store.select(AppState.canSwitchProfile);

  @HostListener('keydown', ['$event'])
  manage(event) {
    this.keyManager.onKeydown(event);
  }

  constructor(private store: Store) {}

  public get isSwitchProfileModalOpen(): boolean {
    return this._isSwitchProfileModalOpen;
  }

  public closeSwitchProfileModal() {
    this._isSwitchProfileModalOpen = false;
  }

  public openSwitchProfileModal(event: Event) {
    event.preventDefault();

    this._isSwitchProfileModalOpen = true;
  }

  ngAfterViewInit() {
    this.keyManager = new FocusKeyManager(this.items).withWrap();
  }

  switchProfile() {
    if (!this.store.selectSnapshot(AppState.canSwitchProfile)) {
      return;
    }

    this.store.dispatch(new SwitchProfile());
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  logout(e: MouseEvent) {
    e.preventDefault();
    this.store.dispatch(new Logout());
  }
}
